// extracted by mini-css-extract-plugin
export default {"container":"AbilityItems_container__Iw2JJ","content":"AbilityItems_content__mt1b0"};